import React from 'react';
import Header from '../../components/Header';
import Hero from '../../components/Hero';
import Features from '../../components/Features';
import Recipes from '../../components/Recipes';
import Download from '../../components/Download';
import Footer from '../../components/Footer';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const HomePage: React.FC = () => {
  const { i18n, t } = useTranslation();

  return (
    <HelmetProvider>
      <div className="App">
        <Helmet>
          <html lang={i18n.language} />
          <title>{t('hero.title')}</title>
          <meta name="description" content={t('hero.description')} />
          <meta name="keywords" content={t('meta.keywords')} />
          <meta property="og:title" content={t('hero.title')} />
          <meta property="og:description" content={t('hero.description')} />
          <meta property="og:type" content="website" />
          <meta property="og:site_name" content="FoodQuick" />
        </Helmet>
        <Header />
        <Hero />
        <Features />
        <Recipes />
        <Download />
        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default HomePage;
